import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getLogsRequest = async (token, startDate, endDate) => {
  const url = `${apiURl}logs/getall?startDate=${startDate}&endDate=${endDate}`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export { getLogsRequest };
